export default __webpack_public_path__ + "static/masculine-f06e9070c18b74ab301510f7ca733607.gltf";